import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import ReactMarkdown from 'react-markdown';
import { useEffect, useState } from "react";
import { useTranslations } from "@/hooks/use-translations";
import { useLocale } from "@/components/locale-provider";

export default function PrivacyNotice() {
  const [content, setContent] = useState('');
  const { locale } = useLocale();
  const { t } = useTranslations(locale);

  useEffect(() => {
    // Load privacy notice from the correct path
    fetch('/privacy-notice.md')
      .then(response => response.text())
      .then(text => setContent(text))
      .catch(error => console.error('Error loading privacy notice:', error));
  }, [locale]); // Re-fetch when locale changes

  return (
    <div className="bg-[#301c36] min-h-screen w-full">
      {/* Desktop Version */}
      <div className="hidden md:block w-full min-h-screen bg-[#301c36]">
        <div className="max-w-[1920px] mx-auto px-4 pb-20 pt-[56.50px]">
          {/* Back Link and Logo */}
          <div className="flex justify-start items-center mt-10">
            <Link href="/" className="inline-flex space-x-4 items-center text-[#c39d63] hover:text-[#b38d53]">
              <ArrowLeft className="w-10 h-10" />
              <div className="w-[99.12px] h-10">
                <img 
                  src="/assets/upper-left-28x-logo.svg" 
                  alt="28X Logo"
                  className="w-[56.57px] h-[39.98px]"
                />
              </div>
            </Link>
          </div>

          {/* Main Content */}
          <div className="flex flex-col items-center justify-start mt-[100px] mb-20">
            {/* Header */}
            <div className="flex flex-col items-start justify-start w-[922px] mb-16">
              <h1 className="text-[90px] font-serifbold leading-[67.01px] text-[#dfd968]">
                {t('privacy').title}
              </h1>
              <p className="text-[42px] italic font-lightitalic leading-[70px] text-right text-[#f1eebc] w-full">
                {t('privacy').subtitle}
              </p>
            </div>

            {/* Markdown Content */}
            <div className="prose prose-invert max-w-[900px] mx-auto">
              <ReactMarkdown>
                {content}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="md:hidden min-h-screen bg-[#301c36] pb-20">
        {/* Back Link and Logo */}
        <div className="flex justify-start items-center p-4">
          <Link href="/" className="inline-flex space-x-2 items-center text-[#c39d63] hover:text-[#b38d53]">
            <ArrowLeft className="w-7 h-7" />
            <div className="w-[69.38px] h-7">
              <img 
                src="/assets/upper-left-28x-logo.svg" 
                alt="28X Logo"
                className="w-[39.60px] h-[27.99px]"
              />
            </div>
          </Link>
        </div>

        <div className="px-4">
          {/* Header */}
          <div className="mt-[156px] mb-12">
            <div className="w-full">
              <h1 className="text-[72.90px] font-serifbold leading-[39.40px] text-[#dfd968]">
                {t('privacy').title}
              </h1>
              <p className="text-[72.90px] font-serifbold leading-[39.40px] text-right text-[#dfd968] mt-6" />
            </div>
            <p className="text-[26px] italic font-lightitalic leading-[41.15px] text-right text-[#f1eebc] mt-4">
              {t('privacy').subtitle}
            </p>
          </div>

          {/* Main Content */}
          <div className="prose prose-invert max-w-full mx-auto mt-8">
            <ReactMarkdown>
              {content}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
}